import * as bd from 'react-basic-design';
import { useField } from 'formik';
import { translate } from '../basic/text';

export const FormikCellToggle = ({
    isHidden = false,
    title = '',
    radio = false,
    id = '',
    readOnly = false,
    className = '',
    onChange = undefined,
    ...props
}) => {
    let [field, , helper] = useField({ ...props });
    if (isHidden) return null;
    if (id === undefined) id = props.name;

    if (!field.value) field.value = false;

    const setModelHandler = value => {
        if (readOnly) return;
        const ev = { target: { ...field, ...props, value } };
        helper.setValue(value);
        if (onChange) onChange(ev);
    };

    return (
        <bd.Toggle
            label={translate(title)}
            id={id}
            radio={radio}
            {...props}
            readOnly={readOnly}
            size="sm"
            className={className}
            model={!!field.value}
            setModel={setModelHandler}
        />
    );
};
